import { gql } from "@apollo/client";

export const GENERATE_DOCUMENT = gql`
  mutation GenerateDocument($input: GenerateDocumentInput!) {
    generateDocument(input: $input) {
      mrn
    }
  }
`;
